import React from "react";
import { Link } from "react-router-dom";
import './footer.css';
import logo from '../../assets/sastiride-logo-white.svg';

const Footer = () => {
  return (
    <div className="gpt3__footer section__padding">
      {/*
      <div className="gpt3__footer-heading">
        <h1 className="gradient__text">Do you want to step in to the future before others</h1>
      </div>

      <div className="gpt3__footer-button">
        <p>Request Early Access</p>
      </div>
      */}
      

      <div className="gpt3__footer-content">
        <div className="gpt3__footer-content__logo">
          <Link to="/"><img src={logo} alt="SastiRide - Ride Sharing Pakistan" /></Link>
        </div>

        <div className="gpt3__footer-content__div">
          <h4 className="gradient__text">Links</h4>
          <p><Link to="/">Home</Link></p>
          <p><Link to="/">Feed</Link></p>
          <p><Link to="/profile">Profile</Link></p>
        </div>
        
        <div className="gpt3__footer-content__div">
          <h4 className="gradient__text">Company</h4>
          <p><Link to="/terms">Terms of Service</Link></p>
          <p><Link to="/privacy">Privacy Policy</Link></p>
          <p><Link to="/faqs">FAQs</Link></p>
        </div>

        <div className="gpt3__footer-content__div">
          <h4 className="gradient__text">Get in touch</h4>
          <p><a href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}>{process.env.REACT_APP_CONTACT_EMAIL}</a></p>
        </div>
      </div>

      <div className="gpt3__footer-copyright">
        {/*<p><a href="mailto:contact@sastiride.com">contact@sastiride.com</a></p>*/}
        <p>© {new Date().getFullYear()} <a href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}>SastiRide</a>. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Footer;